//Library Imports
import React, { memo, useEffect, useState } from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styled from "styled-components";
import { Collapse, Menu, Dropdown } from "antd";

//Local Imports
import Temp1 from "../../../assets/img/Temp1.png";
import Temp2 from "../../../assets/img/Temp2.png";
import Temp3 from "../../../assets/img/Temp3.png";
import Temp4 from "../../../assets/img/Temp4.png";
import Default from "../../../assets/img/icons/Default.svg";
import { change_template_style } from "../Scripts/DynamicStripo";
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { ALLOWED_ADMIN_IDS_FOR_I2C, I2C_ADMIN_ID } from '../../../constants/index';


const selectItem = (handle: (id: number) => void, id: number) => (
  <Menu className="temp-dropdown">
    <Menu.Item className="mr" onClick={() => handle(id)} >
      <div className="list-item">
        <img src={Default} alt="hoc-email" />
        <span className="option-name">Set as Default</span>
      </div>
    </Menu.Item>
  </Menu>
);

const { Panel } = Collapse;

const responsive = {
  Desktop: {
    breakpoint: { max: 4000, min: 0 },
    items: 2,
  },
};

type TemplateSwitchProps = {
  changeTemplate: (value: number, value1: string) => void;
  setTemplateStyleId: (value: number) => void;
  enableSaveButtons: (value: boolean) => void;
  handleDefaultTemplate: (template_style_id: number) => void;
  disabled: boolean;
  templateStyleId: number;
};

const TemplateSwitch: React.FC<TemplateSwitchProps> = (props: TemplateSwitchProps) => {
  const { changeTemplate, setTemplateStyleId, enableSaveButtons, disabled, templateStyleId, handleDefaultTemplate } = props;
  const adminId = useSelector((state: RootState) => state?.user?.userData?.admin_id);
  const userId = useSelector((state: RootState) => state?.user?.userData?.user_id);

  const Template1 = (
    <div className={`template-col template-col-sidbar pb-3`}>
      <a
        href="javascript: void(0);"
        className={`pt-1 w-100 d-block ${templateStyleId.toString() === "0" ? "active" : ""}`}
        data-template-id="0"
        data-toggle="modal"
        data-target="#confirm-template-change"
        onClick={(e) => {
          if (!e.currentTarget.className.includes("active")) {
            enableSaveButtons(true);
            setTemplateStyleId(0);
            change_template_style(0, changeTemplate, enableSaveButtons);
          }
        }}
      >
        <span className="template-icon-box d-block white-background">
          <img src={Temp1} alt="Temp1" />
        </span>
        <span className="d-block template-name pt-1 pb-1 text-center">Traditional: 2 Columns</span>
      </a>
      <div className="default-dropdown">
        <Dropdown
          overlayClassName="Popover-default"
          overlay={selectItem(handleDefaultTemplate, 0)}
          placement="bottomRight"
          arrow={false}
          trigger={["click"]}
          getPopupContainer={() => document.querySelectorAll(".my-templates")[0] as HTMLElement}
        >
          <span className="oppener-dropdown"></span>
        </Dropdown>
      </div>
    </div>
  )

  const Template2 = (
    <div className={`template-col template-col-sidbar pb-3 `}>
      <a
        href="javascript: void(0);"
        className={`pt-1 w-100 d-block ${templateStyleId.toString() === "1" ? "active" : ""}`}
        data-template-id="1"
        data-toggle="modal"
        data-target="#confirm-template-change"
        onClick={(e) => {
          if (!e.currentTarget.className.includes("active")) {
            enableSaveButtons(true);
            setTemplateStyleId(1);
            change_template_style(1, changeTemplate, enableSaveButtons);
          }
        }}
      >
        <span className="template-icon-box d-block white-background">
          <img src={Temp2} alt="Temp2" />
        </span>
        <span className="d-block template-name pt-1 pb-1 text-center">Contemporary: 2 Columns</span>
      </a>
      <div className="default-dropdown">
        <Dropdown
          overlayClassName="Popover-default"
          overlay={selectItem(handleDefaultTemplate, 1)}
          placement="bottomRight"
          arrow={false}
          trigger={["click"]}
          getPopupContainer={() => document.querySelectorAll(".my-templates")[0] as HTMLElement}
        >
          <span className="oppener-dropdown"></span>
        </Dropdown>
      </div>
    </div>
  )

  //* i2c Template 1
  const Template3 = (
    <div className={`template-col template-col-sidbar pb-3`}>
      <a
        href="javascript: void(0);"
        className={`pt-1 w-100 d-block ${templateStyleId.toString() === "2" ? "active" : ""}`}
        data-template-id="2"
        data-toggle="modal"
        data-target="#confirm-template-change"
        onClick={(e) => {
          if (!e.currentTarget.className.includes("active")) {
            enableSaveButtons(true);
            setTemplateStyleId(2);
            change_template_style(2, changeTemplate, enableSaveButtons);
          }
        }}
      >
        <span className="template-icon-box d-block white-background">
          <img src={Temp3} alt="Temp3" />
        </span>
        <span className="d-block template-name pt-1 pb-1 text-center">FinTech Newsletter</span>
      </a>
      <div className="default-dropdown">
        <Dropdown
          overlayClassName="Popover-default"
          overlay={selectItem(handleDefaultTemplate, 2)}
          placement="bottomRight"
          arrow={false}
          trigger={["click"]}
          getPopupContainer={() => document.querySelectorAll(".my-templates")[0] as HTMLElement}
        >
          <span className="oppener-dropdown"></span>
        </Dropdown>
      </div>
    </div>
  )

  //* i2c Template 2
  const Template4 = (
    <div className={`template-col template-col-sidbar pb-3`}>
      <a
        href="javascript: void(0);"
        className={`pt-1 w-100 d-block ${templateStyleId.toString() === "3" ? "active" : ""}`}
        data-template-id="3"
        data-toggle="modal"
        data-target="#confirm-template-change"
        onClick={(e) => {
          if (!e.currentTarget.className.includes("active")) {
            enableSaveButtons(true);
            setTemplateStyleId(3);
            change_template_style(3, changeTemplate, enableSaveButtons);
          }
        }}
      >
        <span className="template-icon-box d-block white-background">
          <img src={Temp4} alt="Temp4" />
        </span>
        <span className="d-block template-name pt-1 pb-1 text-center">Simple</span>
      </a>
      <div className="default-dropdown">
        <Dropdown
          overlayClassName="Popover-default"
          overlay={selectItem(handleDefaultTemplate, 3)}
          placement="bottomRight"
          arrow={false}
          trigger={["click"]}
          getPopupContainer={() => document.querySelectorAll(".my-templates")[0] as HTMLElement}
        >
          <span className="oppener-dropdown"></span>
        </Dropdown>
      </div>
    </div>
  )

  const [templatesArray, setTemplatesArray] = useState([Template1, Template2]);

  useEffect(() => {
    /* only show Template 3 and Template 4 for i2c users */
    if ((ALLOWED_ADMIN_IDS_FOR_I2C.includes(adminId) || ALLOWED_ADMIN_IDS_FOR_I2C.includes(userId)) && templatesArray.length <= 2) {
      setTemplatesArray([Template1, Template2, Template3, Template4]);
    }
  }, [adminId])


  return (
    <Wrapper className="my-templates">
      <div className="accordion select-template-accordion">
        <Collapse defaultActiveKey={["1"]} >
          <Panel header="Select Template" key="1" id="select-template" className="collapse show">
            <div className="card-body">
              <div id="template-container" className="row justify-content-between">
                <Carousel
                  containerClass="carousel-container"
                  responsive={responsive}
                  renderButtonGroupOutside={true}
                  arrows={true}
                >
                  {templatesArray}
                </Carousel>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
    </Wrapper>
  );
};

export default memo(TemplateSwitch);

const Wrapper = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  background: #fff;
  position:relative;
  .Popover-default{
    .temp-dropdown{
      padding:0;
      float: left;
      border-radius: 3px;
      border: 0.5px solid #949494;
      li{
        float: left;
        padding:0;
        min-width:150px;
      }
      .list-item{
        padding:14px;
        float:left;
        img{
          width:16px;
          height:16px;
          float:left;
        }
        span{
          color:#555555;
          font-family: "robotomedium";
          font-weight: 600;
          font-size: 12px;
          line-height: 18px;
          float:left;
          display:inline-block;
          padding-left:10px;
        }
      }
    }
  }
  .select-template-accordion {
    .card-body {
      padding: 0;
    }
    .card-header button {
      font-family: "robotomedium";
      text-align: left;
      font-weight: 600;
      svg {
        float: right;
      }
    }
  }
  .carousel-container {
    padding: 0;
    .react-multi-carousel-track {
      min-width: 100%;
    }
    .react-multi-carousel-item {
      flex: none !important;
    }
    .react-multiple-carousel__arrow {
      position: absolute;
      outline: 0;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      border-radius: 35px;
      z-index: 10;
      border: 0;
      background: #fff;
      min-width: 43px;
      min-height: 43px;
      opacity: 1;
      cursor: pointer;
      box-shadow: 0 0 14px 5px rgb(0 0 0 / 10%);
      top: 45%;
      &.react-multiple-carousel__arrow--left {
        min-width: 43px;
        width: 43px;
        left: 10px;
        &::before {
          margin-left: -3px;
        }
      }
      &.react-multiple-carousel__arrow--right {
        min-width: 43px;
        width: 43px;
        right: 10px;
        &::before {
          margin-right: -4px;
        }
      }
      &::before {
        color: #424b50;
      }
    }
  }
  .template-col {
    position:relative;
    .template-name {
      font-family: "Roboto Slab", serif;
    }
    .template-icon-box {
      svg,
      img {
        max-width: 100%;
        height: auto;
      }
    }
    &.disabled {
      pointer-events: none;
      opacity: 0.6;
    }
    .default-dropdown{
      .oppener-dropdown{
        background-color:#FFFFFF;
        padding: 0 1px;
        font-size: 10px !important;
        color:#5f5f5f;
        position: absolute;
        top: 8px;
        right: 13px;
        height: 13px;
        border-radius: 0px;
        opacity:0;
        transition: 0.5s;
        @media all and (max-width: 1439px), (max-height: 729px), 
        (-webkit-device-pixel-ratio: 1.25) {
          bottom: 43px;
        }
        &:before {
          content: '...';
          display: inline-block;
          width: 0.8em;
          text-align: center;
          font-size: 40px;
          line-height: 0px;
          font-family: 'robotoregular';
          cursor: pointer;
          margin-top: -7px;
          float: right;
          color:#424B50;
          letter-spacing: -2px;
        }
        ul{
          display:block;

        }
      }
    }
    &:hover{
      .default-dropdown{
        .oppener-dropdown{
           opacity:1;
        }
      }
    }
  }
  .ant-collapse-item {
    .ant-collapse-header {
      width: 100%;
      padding-left: 12px !important;
      background: #fff;
      font-weight: bold;
      color: #263153 !important;
      display: block;
      text-align: left;
      font-size: 1rem;
      font-family: "Roboto Slab", serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
        line-height: 14px;
      }
      .anticon {
        right: 12px;
        left: auto !important;
        font-size: 14px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          top: 0px;
        }
        svg {
          transform: rotate(90deg) !important;
          path {
            stroke: #000;
            stroke-width: 60px;
          }
        }
      }
    }
    &.ant-collapse-item-active {
      .ant-collapse-header {
        .anticon svg {
          transform: rotate(270deg) !important;
        }
      }
    }
  }
`;
